import {Component} from "react"
import "./TermsOfUsePage.css"

class TermsOfUsePage extends Component<any> {

    render() {
        return (
            <div className="info-page-container">
                <div className="info-content-container">
                    <div className="info-header">
                        <h1 className="info-title">Terms of Use</h1>
                        <p className="info-subtitle">Important information about our service</p>
                    </div>
                    
                    <div className="info-content" id="terms-of-use">
                        <div className="info-card">
                            <div className="info-icon">⚠️</div>
                            <h2 className="info-card-title">Disclaimer</h2>
                            <p className="info-card-text">
                                The house valuation estimates provided are for informational purposes only and should not be considered as financial or professional advice.
                            </p>
                        </div>
                        
                        <div className="info-card">
                            <div className="info-icon">📊</div>
                            <h2 className="info-card-title">Data Accuracy</h2>
                            <p className="info-card-text">
                                While we strive to provide accurate valuations based on available market data, property values can vary significantly based on numerous factors including condition, market conditions, and local factors not captured in our analysis.
                            </p>
                        </div>
                        
                        <div className="info-card">
                            <div className="info-icon">🔍</div>
                            <h2 className="info-card-title">Professional Advice</h2>
                            <p className="info-card-text">
                                For important financial decisions regarding property, we strongly recommend consulting with qualified real estate professionals, appraisers, or financial advisors who can provide personalized advice based on your specific circumstances.
                            </p>
                        </div>
                        
                        <div className="info-card">
                            <div className="info-icon">📝</div>
                            <h2 className="info-card-title">Service Usage</h2>
                            <p className="info-card-text">
                                By using HomeIndex, you agree to use our service responsibly and understand that our valuations are estimates only. We reserve the right to modify or discontinue our service at any time.
                            </p>
                        </div>
                        
                        <div className="info-card">
                            <div className="info-icon">🛡️</div>
                            <h2 className="info-card-title">Limitation of Liability</h2>
                            <p className="info-card-text">
                                HomeIndex and its operators shall not be liable for any decisions made based on the information provided through our service. Users assume full responsibility for any actions taken based on our valuation estimates.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TermsOfUsePage